import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { connect } from "react-redux";
import {
  Table,
  TableBody,
  TableCell,
  TableRow,
} from "../../styled-components/Table";
import ExpandableCell from "./ExpandableCell";
import Constants from "../../constants/orderStatusTable";
import LuciPropTypes from "../../propTypes/";
import { actions as axisOrderActions } from "../../actions/axisOrders";
import { localizeAxis as localize } from "../../util/localizeUtils";

const OrderItemListItem = styled.li`
  width: 108.75%;
`;

const Content = styled.div`
  display: flex;
  align-items: center;
`;

const OrderItemList = styled.ul`
  list-style-position: inside;
  list-style-type: ${(props) => (props.noBullet ? "none" : "disc")}
  margin: 0;
  padding-left: 0;
`;

const ExpandIcon = styled.span`
  margin-right: 0.5rem;
`;

const OrderLink = styled.a`
  text-decoration: underline;
`;

const Icon = styled.img`
  margin-left: 0.5rem;
  height: auto;
`;

const NeedsApprovalIcon = (url) => (
  <a href={url} target="_blank" rel="noopener noreferrer">
    <Icon
      src="images/thumbup.png"
      alt={localize("needsApprovalTooltip")}
      title={localize("needsApprovalTooltipi")}
    />
  </a>
);

class OrderStatusTable extends Component {
  renderOrderRow = (order) => {
    const orderItemsTitle = (
      <OrderItemList>
        {order.items &&
          order.items.map((item) => (
            <OrderItemListItem key={item.id}>{item.title}</OrderItemListItem>
          ))}
      </OrderItemList>
    );

    const orderItemsStatus = (
      <OrderItemList noBullet>
        {order.items &&
          order.items.map((item) => (
            <OrderItemListItem key={item.id}>
              {item.fileStatus ? item.fileStatus : "---"}
            </OrderItemListItem>
          ))}
      </OrderItemList>
    );

    const orderId = (
      <div>
        <ExpandIcon>{order.expanded ? "-" : "+"}</ExpandIcon>
        <OrderLink href={order.url} target="_blank" rel="noopener noreferrer">
          {order.displayId}
        </OrderLink>
      </div>
    );
    return (
      <TableRow key={order.id}>
        <TableCell width={Constants.ID_COLUMN_WIDTH}>
          <ExpandableCell
            content={orderId}
            expanded={!!order.expanded}
            toggleVisibility={() =>
              this.props.toggleOrderItemsVisibility(order.id, !order.expanded)
            }
          />
        </TableCell>
        <TableCell width={Constants.TITLE_COLUMN_WIDTH}>
          <ExpandableCell
            content={
              <Content expanded={!!order.expanded}>{order.title}</Content>
            }
            expandableContent={orderItemsTitle}
            expanded={!!order.expanded}
            toggleVisibility={() =>
              this.props.toggleOrderItemsVisibility(order.id, !order.expanded)
            }
          />
        </TableCell>
        <TableCell width={Constants.STATE_COLUMN_WIDTH}>
          <ExpandableCell
            content={
              <Content expanded={!!order.expanded}>
                {order.workflowState}
                {order.approvalRequested ? NeedsApprovalIcon(order.url) : ""}
              </Content>
            }
            expandableContent={orderItemsStatus}
            expanded={!!order.expanded}
            toggleVisibility={() =>
              this.props.toggleOrderItemsVisibility(order.id, !order.expanded)
            }
          />
        </TableCell>
        <TableCell width={Constants.PROJECT_COLUMN_WIDTH}>
          <ExpandableCell
            content={
              <Content expanded={!!order.expanded}>{order.project}</Content>
            }
            expanded={!!order.expanded}
            toggleVisibility={() =>
              this.props.toggleOrderItemsVisibility(order.id, !order.expanded)
            }
          />
        </TableCell>
        <TableCell width={Constants.DEADLINE_COLUMN_WIDTH}>
          <ExpandableCell
            content={
              <Content expanded={!!order.expanded}>{order.deadline}</Content>
            }
            expanded={!!order.expanded}
            toggleVisibility={() =>
              this.props.toggleOrderItemsVisibility(order.id, !order.expanded)
            }
          />
        </TableCell>
      </TableRow>
    );
  };

  render() {
    const { orders } = this.props;
    return (
      <Table fontSize="11px" width="100%">
        <TableBody overflowY="scroll">
          {orders.map((order) => this.renderOrderRow(order))}
        </TableBody>
      </Table>
    );
  }
}

OrderStatusTable.defaultProps = {
  orders: [],
};

OrderStatusTable.propTypes = {
  orders: PropTypes.arrayOf(LuciPropTypes.AxisOrder),
  toggleOrderItemsVisibility: PropTypes.func.isRequired,
};

const mapActionCreators = {
  toggleOrderItemsVisibility: axisOrderActions.toggleOrderItemsVisibility,
};

export default connect(null, mapActionCreators)(OrderStatusTable);



// WEBPACK FOOTER //
// ./app/components/DeliveryStatus/OrderStatusTable.js